var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "13px",
    viewBox: "0 0 14 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 22") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "View-Previous-Loan-Stages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Loan-Stage_-PreClose_Loan-Details",
    transform: "translate(-688.000000, -415.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(665.000000, 390.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(21.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(2.875000, 2.875000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Icon-Path",
    points: "0 10.5 12.25 10.5 12.25 11.6666667 0 11.6666667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2375,3.0625 C10.5875,2.7125 10.5875,2.1875 10.2375,1.8375 L8.6625,0.2625 C8.3125,-0.0875 7.7875,-0.0875 7.4375,0.2625 L0.875,6.825 L0.875,9.625 L3.675,9.625 L10.2375,3.0625 Z M8.05,0.875 L9.625,2.45 L8.3125,3.7625 L6.7375,2.1875 L8.05,0.875 Z M1.75,8.75 L1.75,7.175 L6.125,2.8 L7.7,4.375 L3.325,8.75 L1.75,8.75 Z",
    id: "Icon-Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWhite);
export default __webpack_public_path__ + "static/media/Edit_white.3035a69075c39cea4c71a0882f4d07c0.svg";
export { ForwardRef as ReactComponent };